import React, { useState, useEffect, useRef } from "react";
import NavItem from "../NavItem/NavItem";
import * as styles from "./NavSearch.module.scss";
import * as secondaryStyles from "../NavItem/NavLink.module.scss";

import classNames from "classnames/bind";
import { t, Trans } from "@lingui/macro";
import { Icon } from "@silversea-ssc/ui-components-react";
const cx = classNames.bind({ ...secondaryStyles, ...styles });

interface NavSearchProps {
  searchUrl: string;
}

const NavSearch: React.FC<NavSearchProps> = ({ searchUrl }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setIsSearchOpen(false);
    }
  };

  // click outside
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // focus input on show
  useEffect(() => {
    if (isSearchOpen) {
      inputRef?.current?.focus();
    }
  }, [isSearchOpen]);

  return (
    <NavItem
      inputRef={containerRef}
      variant="secondary"
      expandOnMobile={true}
      className={cx({
        navSearch: true,
        searchBarExpanded: isSearchOpen
      })}
    >
      <div
        className={styles.searchBarContainer}
        data-content-piece="nav_search"
      >
        <form action={searchUrl}>
          <Icon
            name="search"
            padding={false}
            size="1x"
            className={styles.searchBarPrependIcon}
          />
          <input
            id="nav-search"
            ref={inputRef}
            className={styles.searchInput}
            type="search"
            placeholder={t`Search input placeholder`}
            name="query"
            autoComplete="off"
            autoCorrect="on"
          />
          <button
            className={styles.searchBarSubmit}
            type="submit"
            aria-label={t`search`}
          >
            <label htmlFor="nav-search" className={styles.searchBarSubmitLabel}>
              <Trans id="search">Search</Trans>
            </label>
            <Icon
              name="search"
              padding={false}
              size="1.5x"
              className={styles.searchBarSubmitIcon}
            />
          </button>
        </form>
      </div>
      <button
        className={cx({
          //navLinkSecondary: true,
          openSearchButton: true
        })}
        onClick={() => setIsSearchOpen(!isSearchOpen)}
        aria-hidden
      >
        <Icon
          name="search"
          padding={false}
          size="1.5x"
          className={styles.navSearchIcon}
        />
      </button>
    </NavItem>
  );
};

export default NavSearch;
